import { RoutePlanShipmentResult } from './RoutePlanShipmentResult';

export class RoutePlanResponse {
  /** Id of the created (or attached) route plan; used to attach a retry to the
   * same plan instead of forging a duplicate. */
  routePlanId?: number;
  shipments: RoutePlanShipmentResult[] = [];

  constructor(opts: RoutePlanResponse) {
    this.routePlanId = opts.routePlanId;
    this.shipments = opts.shipments.map((s) => new RoutePlanShipmentResult(s));
  }
}
